/* Daily campaign clock: Mexico City stays on UTC-6, independent of visitor timezone. */
(function () {
  const DAY = 86400000;
  const OFFSET = -6 * 3600000;
  function dailySecondsLeft(now) {
    const local = new Date(now + OFFSET);
    let end = Date.UTC(local.getUTCFullYear(), local.getUTCMonth(), local.getUTCDate(), 23, 59) - OFFSET;
    if (end <= now) end += DAY;
    return Math.ceil((end - now) / 1000);
  }
  function campaignSecondsLeft(now, endsAt) {
    if (!endsAt) return dailySecondsLeft(now);
    const end = Date.parse(endsAt);
    return Number.isFinite(end) ? Math.max(0, Math.ceil((end - now) / 1000)) : 0;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { dailySecondsLeft, campaignSecondsLeft };
  if (typeof customElements === 'undefined' || customElements.get('fate-season-popup')) return;

  customElements.define('fate-season-popup', class extends HTMLElement {
    connectedCallback() {
      const dialog = this.querySelector('dialog');
      if (!dialog || this.cleanup) return;
      const preview = Boolean(window.Shopify?.designMode);
      const secondsLeft = () => campaignSecondsLeft(Date.now(), this.dataset.endsAt);
      const key = 'fate-hoodie-season-popup-seen-v1';
      const fields = [...dialog.querySelectorAll('[data-season-unit]')];
      const events = new AbortController();
      const on = (target, name, callback) => target.addEventListener(name, callback, { signal: events.signal });
      let timer, opener, priorFocus, shown = false;
      const seen = () => {
        if (shown) return true;
        try {
          const last = Number(localStorage.getItem(key));
          return last > 0 && Date.now() - last < 7200000;
        } catch { return false; }
      };
      const unlock = () => {
        clearTimeout(timer);
        document.documentElement.classList.remove('fate-season-popup-open');
      };
      const close = () => {
        clearTimeout(opener);
        unlock();
        if (dialog.open) dialog.close();
        if (priorFocus?.isConnected) priorFocus.focus({ preventScroll: true });
      };
      const tick = () => {
        clearTimeout(timer);
        const seconds = secondsLeft();
        [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60]
          .forEach((value, index) => { fields[index].textContent = String(value).padStart(2, '0'); });
        if (seconds === 0 && !preview) { close(); return; }
        if (dialog.open) timer = setTimeout(tick, 1000 - Date.now() % 1000 + 10);
      };
      const show = () => {
        if (!this.isConnected || /\/cart\/?$/.test(location.pathname) || (!preview && (seen() || secondsLeft() === 0))) return;
        if (document.hidden || document.querySelector('dialog[open], .fate-qs-sheet--open')) {
          opener = setTimeout(open, 5000);
          return;
        }
        priorFocus = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.add('fate-season-popup-open');
        shown = true;
        if (!preview) { try { localStorage.setItem(key, String(Date.now())); } catch {} }
        tick();
      };
      const open = () => {
        if (!preview && navigator.locks?.request) navigator.locks.request(key, show).catch(() => {});
        else show();
      };
      on(dialog.querySelector('[data-season-close]'), 'click', close);
      dialog.querySelectorAll('[data-season-cta]').forEach(link => on(link, 'click', close));
      on(dialog, 'cancel', event => { event.preventDefault(); close(); });
      on(dialog, 'close', unlock);
      on(dialog, 'click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close();
      });
      on(document, 'visibilitychange', () => { if (!document.hidden && dialog.open) tick(); });
      this.cleanup = () => { close(); events.abort(); this.cleanup = null; };
      if (preview || !seen()) opener = setTimeout(open, Number(this.dataset.delay) || 0);
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
})();
